module.exports = __webpack_public_path__ + "img/hyperlink.6b82286.svg";